import { Link } from "react-router-dom";
import { Instagram, Youtube, Facebook, Mail } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_barcelona-club-hub/artifacts/9yydi0mf_Logotipo-La-Bombonera-%28Curvas%29.png";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative mt-32 border-t border-white/5 bg-[#030712]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5 flex flex-col gap-6">
            <Link to="/" className="flex items-center gap-4">
              <img src={LOGO_URL} alt="" className="h-14 w-14" />
              <div className="leading-tight">
                <p className="font-display font-extrabold uppercase tracking-tight text-xl">
                  C.D. La Bombonera
                </p>
                <p className="text-[10px] uppercase tracking-[0.28em] text-[#FFB800]">
                  Barcelona · Fundado en 2015
                </p>
              </div>
            </Link>
            <p className="text-white/55 max-w-md text-[15px] leading-relaxed">
              Un club que eligió el deporte como estilo de vida. Desde Barcelona
              al mundo, con valor, profesionalidad y pasión.
            </p>
            <div className="flex gap-3 pt-2">
              {[Instagram, Youtube, Facebook, Mail].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  aria-label="social"
                  data-testid={`footer-social-${i}`}
                  className="h-10 w-10 rounded-full grid place-items-center border border-white/10 hover:border-[#FFB800] hover:text-[#FFB800] transition-colors"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="text-[11px] uppercase tracking-[0.25em] text-[#FFB800] mb-5">
              Navegación
            </p>
            <ul className="flex flex-col gap-3 text-white/70">
              <li><Link className="link-underline" to="/">Inicio</Link></li>
              <li><Link className="link-underline" to="/quienes-somos">Quiénes somos</Link></li>
              <li><Link className="link-underline" to="/titulos">Títulos</Link></li>
              <li><Link className="link-underline" to="/tienda">Tienda</Link></li>
              <li><Link className="link-underline" to="/contacto">Contacto</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-[11px] uppercase tracking-[0.25em] text-[#FFB800] mb-5">
              Contacto
            </p>
            <ul className="flex flex-col gap-3 text-white/70 text-[15px]">
              <li>Barcelona, Cataluña — España</li>
              <li>labomboneradebarcelona.es</li>
            </ul>
          </div>
        </div>

        <div className="divider-glow my-10" />

        <div className="flex flex-col md:flex-row justify-between gap-3 text-xs text-white/40">
          <p>© {new Date().getFullYear()} C.D. La Bombonera de Barcelona. Todos los derechos reservados.</p>
          <p className="font-mono tracking-wider">
            Design by{" "}
            <a
              href="https://thefunnelbox.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-credit-link"
              className="text-white/70 hover:text-[#FFB800] transition-colors link-underline"
            >
              The Funnel Box
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
